import direct from 'ml-direct';
/**
 * Run a direct optimization on the provided data using a sum-of-shapes model.
 * @param data - The observed x/y data to fit.
 * @param sumOfShapes - A function returning the model prediction for a given parameter vector.
 * @param options - Optimization bounds and solver options.
 * @returns The optimized parameter values, the final objective error, and the number of iterations.
 */
export function directOptimization(data, sumOfShapes, options) {
    const { minValues, maxValues, maxIterations, epsilon, tolerance, tolerance2, initialState, } = options;
    const objectiveFunction = getObjectiveFunction(data, sumOfShapes);
    const result = direct(objectiveFunction, 
    // direct internally converts ArrayLike to Float64Array,
    // so we can safely cast minValues and maxValues to number[]
    minValues, maxValues, {
        iterations: maxIterations,
        epsilon,
        tolerance,
        tolerance2,
        initialState,
    });
    const { optima, minFunctionValue, iterations } = result;
    return {
        parameterError: minFunctionValue,
        iterations,
        parameterValues: optima[0],
    };
}
function getObjectiveFunction(data, sumOfShapes) {
    const { x, y } = data;
    const nbPoints = x.length;
    return (parameters) => {
        const fct = sumOfShapes(parameters);
        let error = 0;
        for (let i = 0; i < nbPoints; i++) {
            error += (y[i] - fct(x[i])) ** 2;
        }
        return error;
    };
}
//# sourceMappingURL=directOptimization.js.map